import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { miGenericReports } from '@lenderhub/pages/mi/mi-generic-report-viewer/mi-generic-report-viewer.component';
import { roles } from '@shared/constants';
import { AuthorizeService } from '@shared/services/authorize.service';

@Component({
  selector: 'app-mi-page-nav',
  styleUrls: ['mi-page-nav.component.scss'],
  templateUrl: 'mi-page-nav.component.html',
  imports: [RouterLink, RouterLinkActive],
})
export class MiPageNavComponent {
  private readonly authorizeService = inject(AuthorizeService);

  public get hasPaidCompletionsMi() {
    return this.authorizeService.hasRole(roles.lenderPaidMiRoles.paidCompletionsMi);
  }

  public get hasHostedMi() {
    return this.authorizeService.hasRole(roles.lenderPaidMiRoles.hostedMi);
  }

  public get hasLGSSLenderSpecificMi() {
    return this.authorizeService.hasRole(roles.lenderPaidMiRoles.lGSSLenderSpecificMI);
  }

  public get hasLGSSNewBuildMI() {
    return this.authorizeService.hasRole(roles.lenderPaidMiRoles.lGSSNewBuildMI);
  }

  public get hasLGSSMI() {
    return this.hasLGSSLenderSpecificMi || this.hasLGSSNewBuildMI;
  }

  public get genericReports() {
    return miGenericReports.filter(r => this.authorizeService.hasRole(r.role));
  }
}
